// Hằng marker định danh workspace — tách riêng (không side-effect, không import)
// để resolver load được mà không kéo theo template-bundle-loader (chạy
// findPackageRoot lúc import, nổ khi mock fs trong test).
//
// Marker DUY NHẤT của avatar. KHÁC tên avatar-po (.claude/avatar-po.json) → cô lập 2 CLI.
export const WORKSPACE_MARKER_RELATIVE = ".claude/avatar.json";

// Marker của CLI KIA (avatar-po) — nhận diện "đứng nhầm nhà" để báo lỗi đúng.
export const FOREIGN_WORKSPACE_MARKER_RELATIVE = ".claude/avatar-po.json";
export const FOREIGN_CLI_NAME = "avatar-po";
